export const loginLink = '/login'
export const loginErrorLink = '/loginerror'
export const unauthorizedLink = '/status/unauthorized'
export const dashboardLink = '/dashboard'
export const profileLink = '/profile/:user_id'
export const liveViewLink = '/liveview'
export const mapLink = '/map'
export const playbackLink = '/playback'
export const recordLink = '/playback/recordedvideos'
export const videoPlayerLink = '/playback/recordedvideos/:recordingFileId'
export const videoStatusLink = '/playback/videostatus'
export const managementLink = '/management'
export const userLink = '/users/list'
export const createUserLink = '/users/createUsers'
export const userProfileLink = '/users/list/:user_id'
export const userGroupLink = '/users/groups'
export const editUserGroupLink = '/users/groups/:user_grp_id'
export const cameraLink = '/cameras/list'
export const cameraGroupLink = '/cameras/groups'
export const editCameraGroupLink = '/cameras/groups/:video_sensor_group_id'
export const aclLink = '/access/accessControl'
export const batchAclLink = '/access/batchAccessControl'
export const eventLogLink = '/eventLog'
export const superAdminLink = '/superAdmin/list'
export const createSuperAdminsLink = '/superAdmin/createSuperAdmin'
export const crossAgencyListLink = '/superAdmin/crossAgencylist'


export const protectedRouteList = [
   profileLink,
   liveViewLink,
   mapLink,
   playbackLink, recordLink, videoPlayerLink, videoStatusLink,
   managementLink,
   userLink, createUserLink, userProfileLink,
   userGroupLink, editUserGroupLink,
   cameraLink,
   cameraGroupLink, editCameraGroupLink,
   aclLink, batchAclLink,
   eventLogLink,
   superAdminLink, createSuperAdminsLink, crossAgencyListLink
]

export const routeList = [
   userLink,
   createUserLink,
   userProfileLink,
   userGroupLink,
   cameraLink,
   cameraGroupLink,
   aclLink,
   batchAclLink,
   eventLogLink,
   editUserGroupLink,
   editCameraGroupLink,
   superAdminLink,
   createSuperAdminsLink,
   crossAgencyListLink
]


export const playbackLinks = [
   recordLink,
   videoPlayerLink,
   videoStatusLink
]

export const userManagementRouteList = [
   userLink,
   createUserLink,
   userProfileLink,
   userGroupLink,
   editUserGroupLink
]

export const cameraManagementRouteList = [
   cameraLink,
   cameraGroupLink,
   editCameraGroupLink,
]

export const AclManagementRouteList = [
   aclLink,
   batchAclLink,
]

export const SuperAdminManageRouteList = [
   superAdminLink,
   createSuperAdminsLink,
   crossAgencyListLink
]

export const EventLogRouteList = [
   eventLogLink
]